import Header from './header';
import Footer from './footer';

function App() {
  return (
    <div class="page-wrapper">
    <h1 class="d-none">Jampani Pickles</h1>
  
    <Header />  

        <main class="main">
            <nav class="breadcrumb-nav">
                <div class="container">
                    <ul class="breadcrumb bb-no">
                        <li><a href="/">Home</a></li>
                        <li>About Us</li>
                    </ul>
                </div>
            </nav>
            
            <div class="page-content">
                <div class="container">
                    <section class="introduce mb-10 pb-10">
                        <h2 class="title title-center">
                        Who we are
                        </h2>
                        <p class=" mx-auto text-center" style={{maxWidth: '900px'}}>
                        Tired of your daily bland meals? Add the perfect twist to everyday meals with Jampani pickles. Jampani brings you the most unique and yummiest pickles in town! We have the widest and tastiest range of veg, non-veg pickles! Our products are not limited to these. We offer you quality dry fruits, different types of laddus, and all Indian spices at your doorstep. We work to make your every meal special with our pickles and spices. Do not miss the taste of homemade pickles and laddus because we offer what you crave for.
                        </p>
                        <figure class="br-lg">
                            <img src="assets/img/jampani.jpg" alt="Banner" 
                                width="100%"  style={{backgroundColor: '#D0C1AE'}} />
                        </figure>
                    </section>

                    <section class="count-section mb-10 pb-5">
                        <div class="swiper-container swiper-theme" data-swiper-options="{
                            'slidesPerView': 1,
                            'breakpoints': {
                                '768': {
                                    'slidesPerView': 2
                                },
                                '992': {
                                    'slidesPerView': 3
                                }
                            }
                        }">
                            <div class="swiper-wrapper row cols-lg-3 cols-md-2 cols-1">
                                <div class="swiper-slide counter-wrap">
                                    <div class="counter text-center">
                                        <h4 class="title title-center">We Love What We Do</h4>
                                        <p style={{padding: '0px 20px'}}>
                                             Tired of your daily bland meals? Add the perfect twist to everyday meals with Jampani pickles. Jampani brings you the most unique and yummiest pickles in town! We have the widest and tastiest range of veg, non-veg pickles! Our products are not limited to these.
                                        </p>
                                    </div>
                                </div>
                                <div class="swiper-slide counter-wrap">
                                    <div class="counter text-center">
                                        <h4 class="title title-center">Our Working Process</h4>
                                        <p style={{padding: '0px 20px'}}>
                                             Our team is made up of committed employees that excel in their jobs. Every member of the team upholds fundamental standards and works diligently to keep the environment clean.
                                        </p>
                                    </div>
                                </div>
                                <div class="swiper-slide counter-wrap">
                                    <div class="counter text-center">
                                        <h4 class="title title-center">What We Offer</h4>
                                        <p style={{padding: '0px 20px'}}>
                                            We offer you quality dry fruits, different types of laddus, and all Indian spices at your doorstep. We work to make your every meal special with our pickles and spices. Do not miss the taste of homemade pickles and laddus because we offer what you crave for.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </section>
                </div>
            </div>
            
        </main>

        <Footer />
    
    
</div>
  );
}

export default App;
